import { zumperApi } from "api/zumper";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { IntegrationLogoIcon } from "views/settings-integration/components/IntegrationLogoIcon";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const ZumperView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectZumper, isPending: isDisconnecting } = useMutation({
    mutationKey: ["ZUMPER", "DELETE"],
    mutationFn: () => zumperApi.disconnect(),
    onSuccess: () => {
      toast.success("Zumper integration disconnected successfully");
      refreshPartnerData();
      navigate("/settings/integration");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                { title: "Settings", href: "/settings" },
                { title: "Integration", href: "/settings/integration" },
                { title: "Zumper", href: "/settings/integration/zumper" }
              ]}
            />
          </div>
          <div className="flex items-center justify-between px-6 py-4 border-b border-alpha-40">
            <div className="flex items-center gap-4">
              <IntegrationLogoIcon id={IntegrationId.ZUMPER} size="SM" />
              <p className="text-xl font-bold text-content-1000">Zumper</p>
            </div>
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              HugeIcon={Cancel01Icon}
              onClick={() => disconnectZumper()}
              loading={isDisconnecting}
            >
              Disconnect
            </Button>
          </div>
        </>
      }
    >
      <Card className="w-full p-6 max-w-[800px]">
        <p className="text-base font-bold text-content-1000">
          Zumper Integration
        </p>
        <p className="mt-2 text-sm text-content-400">
          Your listings are being published to Zumper&apos;s rental marketplace.
          To stop publishing, disconnect this integration.
        </p>
      </Card>
    </Layout>
  );
};
